<script setup lang="ts" generic="Value">
import { EMPTY_FIELD_SIGN } from '@/components/forms/utils.ts';
import { SelectItemTypeObject } from '../types';

interface FormSelectionDisplayProps {
  value?: SelectItemTypeObject<Value>[];
  plainText?: boolean;
}

defineProps<FormSelectionDisplayProps>();
</script>

<template>
  <div v-if="value">
    <template v-if="value.length">
      <template v-if="plainText">
        <span v-for="item in value" :key="item.title">
          {{ item.title }}
        </span>
        <span v-if="value.length > 1">, </span>
      </template>
      <v-chip v-for="item in value" v-else :key="item.title" class="mr-1 mb-2">
        <slot v-if="$slots.itemTitle" name="itemTitle" v-bind="item" />
        <span v-else>{{ item.title }}</span>
      </v-chip>
    </template>
    <template v-else>{{ EMPTY_FIELD_SIGN }}</template>
  </div>
</template>
